import apiProduct from '@/api/public/product';

const defaultState = () => ({
	productInternal: [],
	loadProductInternal: false,
	productInternalPagination: '',

	detailProduct: {},

	products: [],
	loadProducts: false,
	productsPagination: '',

	productExternal: [],
	loadProductExternal: false,
	productExternalPagination: '',

	productMostViewed: [],
	productMostViewedPagination: '',

	productMostBuy: [],
	productMostBuyPagination: '',

	productbyStore: [],
	productbyStorePagination: '',

	productTrend: [],
	productTrendPagination: '',

	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setDetailProduct(state, data) {
		state.detailProduct = data
	},

	async setProductInternal(state, data) {
		state.productInternalPagination = await data.pagination;
		state.productInternal = await data.data
	},
	setloadProductInternal(state, data) {
		state.loadProductInternal = data
	},

	setProductExternal(state, data) {
		state.productExternal = data.data
		state.productExternalPagination = data.pagination;
	},
	setMoreProductExternal(state, data) {
		state.productExternal = state.productExternal.concat([ ...data.data ])
		state.productExternalPagination = data.pagination;
	},
	setloadProductExternal(state, data) {
		state.loadProductExternal = data
	},

	setProducts(state, data) {
		state.products = data.data
		state.productsPagination = data.pagination;
	},
	setMoreProducts(state, data) {
		state.products = state.products.concat([ ...data.data ])
		state.productsPagination = data.pagination;
	},
	setloadProducts(state, data) {
		state.loadProducts = data
	},

	setProductMostViewed(state, data) {
		state.productMostViewed = data.data
		state.productMostViewedPagination = data.pagination
	},
	setProductMostBuy(state, data) {
		state.productMostBuy = data.data
		state.productMostBuyPagination = data.pagination
	},

	setProductbyStore(state, data) {
		state.productbyStore = data.data
		state.productbyStorePagination = data.pagination
	},

	setProductTrend(state, data) {
		state.productTrend = data.data
		state.productTrendPagination = data.pagination
	},

	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data.message
	},
	clearProductExternal(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getProductInternal({ commit }, params) {
		commit('setloadProductInternal', true);
		return new Promise((resolve) => {
			apiProduct.getProductInternal(params).then(({ data: { data } }) => {
				commit('setProductInternal', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductInternal', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProductInternal', false);
			});
		});
	},
	async getProductExternal({ commit }, params) {
		commit('setloadProductExternal', true);
		return new Promise((resolve) => {
			apiProduct.getProductExternal(params).then(({ data: { data } }) => {
				commit('setProductExternal', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductExternal', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProductExternal', false);
			});
		});
	},
	async getProducts({ commit }, params) {
		commit('setloadProducts', true);
		return new Promise((resolve) => {
			apiProduct.getProducts(params).then(({ data: { data } }) => {
				commit('setProducts', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProducts', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProducts', false);
			});
		});
	},
	async getProductsSearch({ commit }, params) {
		commit('setloadProducts', true);
		return new Promise((resolve) => {
			apiProduct.getProductsSearch(params).then(({ data: { data } }) => {
				commit('setProducts', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProducts', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProducts', false);
			});
		});
	},
	async getMoreProducts({ commit }, params) {
		commit('setloadProducts', true);
		return new Promise((resolve) => {
			apiProduct.getProducts(params).then(({ data: { data } }) => {
				commit('setMoreProducts', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setMoreProducts', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProducts', false);
			});
		});
	},
	async getProductMostViewed({ commit }, params) {
		return new Promise((resolve) => {
			apiProduct.getProductMostViewed(params).then(({ data: { data } }) => {
				commit('setProductMostViewed', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductMostViewed', { data: [], pagination: {} });
			})
		});
	},
	async getProductMostBuy({ commit }, params) {
		return new Promise((resolve) => {
			apiProduct.getProductMostBuy(params).then(({ data: { data } }) => {
				commit('setProductMostBuy', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductMostBuy', { data: [], pagination: {} });
			})
		});
	},
	async getMoreProductExternal({ commit }, params) {
		commit('setloadProductExternal', true);
		return new Promise((resolve) => {
			apiProduct.getProductExternal(params).then(({ data: { data } }) => {
				commit('setMoreProductExternal', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setMoreProductExternal', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProductExternal', false);
			});
		});
	},
	async getDetailProduct({ commit, dispatch }, params) {
		return new Promise((resolve,reject) => {
			apiProduct.getDetailProduct(params).then(({ data: { data } }) => {
				commit('setDetailProduct', data.results);
				resolve(true);
				commit('saveResponse', data)
			}).catch((err) => {
				const { data } = err.response;
				// dispatch('errorHandler', data)
				commit('setDetailProduct', {});
        reject(data)
			})
		});
	},
	async getProductByStore({ commit }, params) {
		return new Promise((resolve) => {
			apiProduct.getProductByStore(params).then(({ data: { data } }) => {
				commit('setProductbyStore', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductbyStore', { data: [], pagination: {} });
			})
		});
	},
	async getProductTrend({ commit }, params) {
		return new Promise((resolve) => {
			apiProduct.getProductTrend(params).then(({ data: { data } }) => {
				commit('setProductTrend', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductTrend', { data: [], pagination: {} });
			})
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
